/* eslint-disable react/no-unused-prop-types */
import * as React from "react";
import PausedClusterQueuesNotice from "app/components/shared/PausedClusterQueuesNotice";
import Header from "../Header";
import BuildContentNavigation from "./BuildContentNavigation";
import BuildShowStore, { Build, FaviconPaths } from "app/stores/BuildShowStore";
import {
  BuildContextProvider,
  useBuild,
} from "app/components/Playground/BuildContext";
import JobsPage from "./JobsPage";

const Canvas = React.lazy(
  () =>
    import(
      /* webpackChunkName: "canvas" */ "app/components/Playground/BuildCanvas"
    ),
);

export enum BuildView {
  JobList = "JOB_LIST",
  Waterfall = "WATERFALL",
  Canvas = "CANVAS",
}

type Props = {
  view: BuildView;
};

export function BuildShow({ view }: Props) {
  const { build, store } = useBuild();
  if (!build || !store) {
    throw new Error("Missing build context");
  }

  return (
    <>
      <PausedClusterQueuesNotice
        pausedQueues={build.dispatchPausedClusterQueues}
      />

      <Header
        build={build}
        showRebuild={true}
        store={store}
        currentView={view}
        showJobs={view === BuildView.JobList}
      />

      <BuildContentNavigation
        buildPath={build.path}
        currentView={view}
        waterfallAvailable={store.waterfallAvailable}
      />

      {view === BuildView.JobList && <JobsPage store={store} />}
      {view === BuildView.Canvas && (
        <div
          className="flex-1 relative min-h-[400px] rounded-md mb-4 border border-gray-300 data-[fullscreen=true]:fixed data-[fullscreen=true]:w-screen data-[fullscreen=true]:h-screen data-[fullscreen=true]:border-none data-[fullscreen=true]:rounded-none data-[fullscreen=true]:left-0 data-[fullscreen=true]:top-0 bg-white data-[fullscreen=true]:m-0"
          id="canvas"
        >
          <div className="absolute w-full h-full">
            <React.Suspense fallback={null}>
              <Canvas />
            </React.Suspense>
          </div>
        </div>
      )}
    </>
  );
}

interface PageProps {
  build: Build;
  faviconPaths: FaviconPaths;
  waterfallAvailable: boolean;
  view: BuildView;
}

export default ({ view, ...props }: PageProps) => {
  const store = new BuildShowStore(props);

  return (
    <BuildContextProvider store={store}>
      <BuildShow view={view} />
    </BuildContextProvider>
  );
};
